/**
 * Created by Rodrigo Quesada on 09/03/17.
 */
import {NgModule} from '@angular/core';
import {FileUploaderComponent} from './file-uploader.component';
import {CommonModule} from '@angular/common';
import {FileUploadModule} from 'primeng/components/fileupload/fileupload';

@NgModule({
    imports: [CommonModule, FileUploadModule],
    declarations: [FileUploaderComponent],
    exports: [FileUploaderComponent]
})
export class FileUploaderModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/files/file-uploader/file-uploader.module.ts